import { c as _c } from "react/compiler-runtime";
import { Divider, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { pluralize } from '@/utils/string';
import { SelectedItemsBox } from './selectionPanel/selectedItemsBox';
import { SearchBar } from '../search/searchBar';
export const AddValuesPanel = t0 => {
  const $ = _c(28);
  const {
    entityName,
    selectionEntityName,
    addedValues,
    onAddClick,
    renderItem,
    itemKey,
    onRemove,
    clearAll
  } = t0;
  const [input, setInput] = useState("");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      marginTop: "12px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      padding: "12px 24px"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== entityName) {
    t3 = pluralize(entityName);
    $[2] = entityName;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `Add one or more ${t3}`;
  let t5;
  if ($[4] !== t4) {
    t5 = <Typography variant="body1" sx={t2}>{t4}</Typography>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Divider />;
    t7 = {
      gap: "12px",
      overflow: "hidden"
    };
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      padding: "0 24px 12px"
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== addedValues || $[10] !== entityName || $[11] !== input || $[12] !== onAddClick) {
    t9 = <Stack sx={t8}><SearchBar value={input} setValue={setInput} placeholder={entityName} selectedValues={addedValues} onAddClick={onAddClick} showAddButton={true} hideSearchIcon={true} /></Stack>;
    $[9] = addedValues;
    $[10] = entityName;
    $[11] = input;
    $[12] = onAddClick;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== addedValues || $[15] !== clearAll || $[16] !== entityName || $[17] !== itemKey || $[18] !== onRemove || $[19] !== renderItem || $[20] !== selectionEntityName) {
    t10 = addedValues.length > 0 && <SelectedItemsBox items={addedValues} entityType={selectionEntityName ?? entityName} renderItem={renderItem} itemKey={itemKey} onRemove={onRemove} clearAll={clearAll} />;
    $[14] = addedValues;
    $[15] = clearAll;
    $[16] = entityName;
    $[17] = itemKey;
    $[18] = onRemove;
    $[19] = renderItem;
    $[20] = selectionEntityName;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t9) {
    t11 = <Stack divider={t6} sx={t7}>{t9}{t10}</Stack>;
    $[22] = t10;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t5) {
    t12 = <Stack className="max-h-[480px] overflow-hidden" sx={t1}>{t5}{t11}</Stack>;
    $[25] = t11;
    $[26] = t5;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};